import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

/**
 * Charge une ressource de l'API et la recharge quand `chemin` ou `query` changent.
 * Renvoie { donnees, erreur, chargement, recharger }.
 */
export function useApi(chemin, query) {
  const [etat, setEtat] = useState({ donnees: null, erreur: null, chargement: true });
  const cleQuery = JSON.stringify(query || {});

  const recharger = useCallback(() => {
    if (!chemin) return Promise.resolve();
    setEtat((e) => ({ ...e, chargement: true }));
    return api(chemin, { query: JSON.parse(cleQuery) })
      .then((donnees) => setEtat({ donnees, erreur: null, chargement: false }))
      .catch((erreur) => setEtat((e) => ({ ...e, erreur, chargement: false })));
  }, [chemin, cleQuery]);

  useEffect(() => {
    recharger();
  }, [recharger]);

  return { ...etat, recharger };
}

/**
 * Exécute une action (POST, PUT…) en gérant l'erreur et l'état « en cours ».
 * `executer(fn)` renvoie true si l'action a réussi.
 */
export function useAction() {
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  const executer = useCallback(async (fn) => {
    setEnCours(true);
    setErreur(null);
    try {
      await fn();
      return true;
    } catch (e) {
      setErreur(e);
      return false;
    } finally {
      setEnCours(false);
    }
  }, []);

  return { executer, enCours, erreur, effacerErreur: () => setErreur(null) };
}
